import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-catalog';
export var ID = 'icon-catalog';
/* eslint-disable max-len */

export var SVGCatalog = function SVGCatalog() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 50 50"
  }, React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("rect", {
    x: "0",
    y: "0",
    width: "50",
    height: "50"
  }), React.createElement("path", {
    d: "M25.6545767,15.8701875 C26.6983267,15.0883125 27.9945767,14.6251875 29.3989517,14.6251875 C32.8502017,14.6251875 35.6489517,17.4226875 35.6489517,20.8751875 C35.6489517,24.3264375 32.8502017,27.1251875 29.3989517,27.1251875 C29.1895767,27.1251875 28.9833267,27.1145625 28.7795767,27.0945625 M13,36.6545 C13,37.48075 12.33,38.151375 11.50375,38.151375 C10.676875,38.151375 10.0075,37.48075 10.0075,36.6545 C10.0075,35.82825 10.676875,35.15825 11.50375,35.15825 C12.33,35.15825 13,35.82825 13,36.6545 Z M21.0049817,35.0335 C21.0049817,35.85975 20.3349817,36.52975 19.5087317,36.52975 C18.6824817,36.52975 18.0124817,35.85975 18.0124817,35.0335 C18.0124817,34.20725 18.6824817,33.536625 19.5087317,33.536625 C20.3349817,33.536625 21.0049817,34.20725 21.0049817,35.0335 Z M13,36.6545 L13,26 L21,24 L21,35.035625 M13,28.5 L21,26.5 L13,28.5 Z M14.1248892,13.69125 C16.8230142,7.96375 22.6480142,4 29.3986392,4 C38.7186392,4 46.2736392,11.555 46.2736392,20.875 C46.2736392,30.194375 38.7186392,37.75 29.3986392,37.75 C29.1911392,37.75 28.9848892,37.745625 28.7792642,37.73875 M5,13 L5,45 L28,45 L28,18 L23,13 L5,13 Z M23,13 L23,18 L28,18",
    stroke: "#D9D2D0",
    strokeWidth: "2"
  })));
};
/* eslint-disable max-len */

var Catalog = function Catalog(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGCatalog
  });
};

Catalog.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default Catalog;